export default __webpack_public_path__ + "static/media/recomposer_lite_logo.e30e8781.png";